// extracted by mini-css-extract-plugin
export default {"cardContainer":"FeedAccessTokensSection_cardContainer__2Z27F","card":"FeedAccessTokensSection_card__VMCPG","buttons":"FeedAccessTokensSection_buttons__yxJtR"};